import moment from 'moment'
import React from 'react'
import DeleteOutlineIcon from '@mui/icons-material/DeleteOutline';

export default function AddChild({ name, dateOfBirth, index, onRemove,handleChangeChildState }) {
    return (
        <>
            <p className='child-label'>Child {index + 1} <DeleteOutlineIcon className='pointer' fontSize={'30'} onClick={onRemove} /></p>
            <div className="child-bx">
                <div className="form-box">
                    <label htmlFor={"name"+index}>Name/Nickname</label>
                    <input id={"name"+index} type="text" placeholder='Enter name' className='input-box' defaultValue={name} onChange={(e)=>handleChangeChildState("name",e.target.value,index)} />
                </div>
                <div className="form-box">
                    <label htmlFor={"child"+index}>Date of birth</label>
                    <input max={moment().format("YYYY-MM-DD")} id={"child"+index} type="date" className='input-box' defaultValue={moment(dateOfBirth).format('YYYY-MM-DD')} onChange={(e)=>handleChangeChildState("dob",e.target.value,index)} />
                </div>
            </div>
        </>
    )
}
